import React, { useEffect, useState } from 'react'
import { EditFilled, FilterOutlined, HistoryOutlined, InfoCircleTwoTone } from '@ant-design/icons';
import { Card, Checkbox, Col, Flex, Input, Row, Select, Table, Tag, Tooltip } from 'antd';
import { Pagination } from "@mui/material";
import AuthService from '../../Components/auth/AuthService';
import { encodeId } from '../../Components/common/CommonFun';
import { useLoadingDispatch, showLoading, hideLoading } from "../../context/loadingContext";
import { styled } from '@mui/system';
import { useLocation, useNavigate } from 'react-router-dom';
import { productCategories, productSubcategories } from '../../Components/common/Constants';
import { showMessage } from '../../Components/Utils/message';
import { EXPIRATION_TIME } from '../../Components/common/Constants';
import ProductInfoModal from '../../Components/Modals/ProductInfoModal';
import StockTrailDrawer from '../../Components/Drawers/StockTrailDrawer';
const DataSheet = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;

const AntTable = styled('div')`
  .ant-table-tbody > tr > td {
    border-bottom: '1px solid #b7b9bd';
  }
`;
const Auth = new AuthService();

const ProductsList = () => {
  const { Option } = Select;
  const { Search } = Input;
  const navigate = useNavigate();
  const location = useLocation();
  const layoutDispatch = useLoadingDispatch()

  const [filters, setFilters] = React.useState(() => {
    const existing = localStorage.getItem('ProductsFilters');
    const parsed = existing ? JSON.parse(existing) : {};
    const currentTime = new Date().getTime();

    const defaultFilters = {
      on_hold: false,
      show_inactive: false,
      category: null,
      sub_category: null,
      searchText: "",
      page: 1
    };

    if (parsed.timestamp && currentTime - parsed.timestamp < EXPIRATION_TIME) {
      return { ...defaultFilters, ...parsed };
    }
    localStorage.removeItem('ProductsFilters');
    return defaultFilters;
  });
  const [searchInput, setSearchInput] = useState(filters.searchText || '');

  const updateFilters = (newValues) => {
    const existingString = localStorage.getItem('ProductsFilters');
    const existing = existingString ? JSON.parse(existingString) : {};

    Object.assign(existing, newValues);
    existing.timestamp = new Date().getTime();

    localStorage.setItem('ProductsFilters', JSON.stringify(existing));
  };

  const [totalPages, setTotalPages] = React.useState(0);
  const [limit] = React.useState(50);
  const [totalCount, setTotalCount] = React.useState(null);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStockVisible, setModalStockVisible] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    name: '',
    code: '',
    totalStock: 0

  });

  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedStockRecord, setSelectedStockRecord] = useState(null);
  const [stockTrail, setStockTrail] = useState([]);

  const [allProducts, setAllProducts] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const getStockTrail = async (record) => {
    const selectedProduct = allProducts?.find((item) => item.netsuite_id === record.netsuite_id);
    const productName = `${selectedProduct?.code} - ${selectedProduct?.name}`;
    setSelectedStockRecord(productName);
    setSelectedItem(selectedProduct);
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/product/stock-trail?id=${record?.netsuite_id}`)
      if (res?.ack) {
        if (res?.stock_trail.length > 0) {
          setStockTrail(res?.stock_trail);
          setModalStockVisible(true);
        } else {
          setStockTrail([]);
          setSelectedItem(null)
          showMessage('error', 'No Stock trails found')
        }
      } else {
        setStockTrail([]);
        setSelectedItem(null)

        showMessage('error', res?.message)
      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');

    } finally {
      hideLoading(layoutDispatch)
    }
  }

  const productsCol = [
    {
      title: 'Name',
      render: (record) => {
        const files = record?.files ? JSON.parse(record?.files) : [];
        return (
          <Flex align='center' gap={5}>

            <span>{`${record?.code} - ${record?.name}`}</span>
          </Flex>
        );
      }
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
    },
    {
      title: 'Sub Category',
      dataIndex: 'sub_category',
      key: 'sub_category',
    },
    {
      title: 'Cases in Pallet',
      dataIndex: 'cases_in_pallets',
      key: 'cases_in_pallets',
      render: (cases_in_pallets) => {
        return <Tag color='blue' style={{ fontSize: 16, fontWeight: 'bold' }}>{cases_in_pallets?.toLocaleString() || '0'} </Tag>;

      },
      align: 'center'
    },
    {
      title: 'Quantity',
      render: (record) => {
        return <Tag color={record?.current_quantity > record?.safety_stock_level ? 'green' : 'red'} style={{ fontSize: 16, fontWeight: 'bold' }}>{record?.current_quantity?.toLocaleString() || '0'} </Tag>;
      },
      align: 'center'

    },
    {
      title: 'Safety Stock Level',
      dataIndex: 'safety_stock_level',
      key: 'safety_stock_level',
      render: (safety_stock_level) => {
        return <>{safety_stock_level?.toLocaleString() || '0'} </>;
      },
      align: 'center'

    },
    {
      title: "On Hold",
      render: (record) => {
        return (
          <>
            <span>{record?.on_hold === 0 ? "No" : "Yes"}</span>
          </>
        )
      }
    },
    {
      title: "Status",
      render: (record) => {
        return (
          <>
            <span>{record?.status === 0 ? "Active" : "Inactive"}</span>
          </>
        )
      }
    },
    {
      title: "Action", align: "center", render: (record) => (
        <Flex justify='end' align='center' gap={5}>
          <Tooltip title="Product Info">
            <InfoCircleTwoTone onClick={() => handleSelect(record)} style={{ fontSize: '25px', cursor: "pointer", marginRight: "5px", color: "blue" }} />
          </Tooltip>
          <Tooltip title="Edit Product Details">
            <EditFilled onClick={() => handleRowClick(record.netsuite_id)} style={{ fontSize: '25px', cursor: "pointer", marginRight: "5px", color: "#001529" }} />
          </Tooltip>
          <Tooltip title="Stock Trail">
            <HistoryOutlined onClick={() => getStockTrail(record)} style={{ fontSize: '25px', cursor: "pointer", marginRight: "5px", color: "#001529" }} />
          </Tooltip>
        </Flex>

      ),
      width: 150
    },
  ];

  const handleRowClick = (id) => {
    const hasedID = encodeId(id)
    navigate(`/products/${hasedID}`)
  };

  const handleSelect = async (record) => {
    console.log('record', record)
    setSelectedRecord(record);
    showLoading(layoutDispatch)
    try {
      const res = await Auth.fetch(`/product/product-details?id=${record?.netsuite_id}`)
      if (res?.ack) {
        if (res?.product_details.length > 0) {
          const totalStock = res.product_details.reduce((sum, item) => sum + (Number(item.stock_level) || 0), 0);
          setSelectedItems(res?.product_details);
          setSelectedItemDetails({ ...selectedItemDetails, name: res?.product_details[0]?.name, code: res?.product_details[0]?.code, totalStock: totalStock })
          setModalVisible(true);
        } else {
          setSelectedItems([]);
          showMessage('error', 'No Details')
        }
      } else {
        setSelectedItems([]);
        showMessage('error', res?.message)
      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');

    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const getAllProducts = async () => {
    showLoading(layoutDispatch)
    const payload = {
      limit,
      page: filters.page,
      searchText: (filters.searchText || '').trim(),
      on_hold: filters?.on_hold ? 1 : 0,
      in_active: filters?.show_inactive ? 1 : 0,
    };

    if (filters?.category) {
      payload.category = filters.category;
    }

    if (filters?.sub_category) {
      payload.sub_category = filters.sub_category;
    }
    try {
      const res = await Auth.post(`/product/products`, payload);
      if (res.ack) {
        setAllProducts(res.products)
        setTotalPages(Math.ceil(res.total_count / limit));
        setTotalCount(res?.total_count);

      } else {
        showMessage('error', res?.message)
      }
    } catch (error) {
      console.log(error);
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const handleChange = (event, value) => {
    setFilters(prev => ({ ...prev, page: value }));
    updateFilters({ page: value });
  };


  useEffect(() => {
    getAllProducts()
  }, [filters]);

  const syncProducts = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/product/sync-products`, {
        method: "POST",

      });
      if (res?.ack) {
        showMessage('success', res?.message);
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'something went wrong, Try Again!');
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  const handleModalCancel = () => {
    setSelectedItems([])
    setModalVisible(false);

  };

  const handleModalCancelStock = () => {
    setStockTrail([])
    setModalStockVisible(false);
    setSelectedStockRecord(null);
  };

  const handleOk = () => {
    setSelectedItems([])
    setModalVisible(false);
  };

  const handleOkStock = () => {
    setStockTrail([])
    setModalStockVisible(false);
    setSelectedStockRecord(null);

  };

  return (
    <DataSheet>
      <Card title={<><FilterOutlined style={{ color: '#6cb8ff' }} /> Products</>}
        style={{ marginBottom: '10px' }}
      >
        <Row gutter={[16, 16]} style={{ width: '100%', display: 'flex', alignItems: 'center' }}>

          <Col xs={24} sm={24} md={8} lg={6} xl={6}>
            <Select
              style={{
                width: "100%",
              }}
              showSearch
              allowClear
              value={filters?.category}
              placeholder="Category"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                setFilters({ ...filters, category: value, page: 1 });
                updateFilters({ category: value, page: 1 });
              }}
            >
              {productCategories?.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item?.title}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={24} md={8} lg={6} xl={6}>
            <Select
              style={{
                width: "100%",
              }}
              showSearch
              allowClear
              value={filters?.sub_category}
              placeholder="Sub Category"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                setFilters({ ...filters, sub_category: value, page: 1 });
                updateFilters({ sub_category: value, page: 1 });
              }}
            >
              {productSubcategories?.map((item) => (
                <Option key={item?.id} value={item.title}>
                  {`${item?.title} - ${item?.Category}`}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={24} md={8} lg={6} xl={6}>
            <Search
              placeholder="Search Products"
              allowClear
              enterButton="Search"
              style={{ width: '100%' }}
              value={searchInput}
              onChange={(e) => {
                const value = e.target.value;
                setSearchInput(value);

                if (!value) {
                  setFilters(prev => ({ ...prev, searchText: '', page: 1 }));
                  updateFilters({ searchText: '', page: 1 });
                }
              }}
              onSearch={(value) => {
                if (!value?.trim()) {
                  showMessage('error', 'Please enter a search value');
                  return;
                }

                setFilters(prev => ({
                  ...prev,
                  searchText: value,
                  page: 1
                }));

                updateFilters({ searchText: value, page: 1 });
              }}
            />
          </Col>
          <Col xs={24} sm={24} md={4} lg={3} xl={3}>
            <Checkbox checked={filters?.on_hold}
              onChange={(e) => {
                const checked = e.target.checked;
                setFilters({ ...filters, on_hold: checked, page: 1 });
                updateFilters({ on_hold: checked, page: 1 });
              }}
              style={{ width: '130px' }}>
              Show On-hold
            </Checkbox>
          </Col>
          <Col xs={24} sm={24} md={4} lg={3} xl={3}>
            <Checkbox checked={filters?.show_inactive}
              onChange={(e) => {
                const checked = e.target.checked;
                setFilters({ ...filters, show_inactive: checked, page: 1 });
                updateFilters({ show_inactive: checked, page: 1 });
              }}
              style={{ width: '150px' }}>
              Show Inactive
            </Checkbox>
          </Col>
        </Row>
      </Card>

      <AntTable>
        <Table
          dataSource={allProducts}
          columns={productsCol}
          pagination={false}
          loading={isLoading}
          footer={() => {
            const startRecord = (filters.page - 1) * limit + 1;
            const endRecord = Math.min(filters.page * limit, allProducts?.length ? totalCount : 0);
            return `Showing ${startRecord}-${endRecord} of ${allProducts?.length ? totalCount : "0"} Records`;
          }}
          rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
          scroll={{ x: 'max-content' }}
        />
      </AntTable>
      <div style={{ float: "right", margin: "10px" }}>
        <Pagination
          page={filters.page}
          count={totalPages}
          variant="outlined"
          color="primary"
          onChange={handleChange}
        />
      </div>

      <ProductInfoModal
        visible={modalVisible}
        onCancel={handleModalCancel}
        selectedItemDetails={selectedItemDetails}
        selectedItems={selectedItems}
        selectedRecord={selectedRecord}
      />

      <StockTrailDrawer
        drawerOpen={modalStockVisible}
        drawerClose={handleModalCancelStock}
        stockTrail={stockTrail}
        selectedStockRecord={selectedStockRecord}
        selectedItem={selectedItem}
      />
    </DataSheet>
  )
}

export default ProductsList;
